import moment from "moment";
import SvgIcon from "../../../../../parts/SvgIcon";

function PlanAnnualPhaseCard({ annualPhases, dayKey }) {
  if (!annualPhases || annualPhases.length === 0) return null;
  const dayUtc = parseInt(moment(dayKey, "YYYY-MM-DD").format("YYYYMMDD"), 10);
  const phase = annualPhases.find(
    (p) => p.startDate <= dayUtc && (!p.endDate || p.endDate >= dayUtc)
  );
  if (!phase) return null;
  return (
    <div className="plan-card plan-card--phase">
      <div className="plan-card__header">
        <SvgIcon src="/img/new-icons/calendar.svg" useCurrentColor={true} />
        {phase.name}
      </div>
    </div>
  );
}

export default PlanAnnualPhaseCard;
